<template>
  <div id="feedback">
    <div class="flex justify-start lg:justify-center mb-[16px] lg:mb-[24px]">
      <h2
        class="font-nutino font-extrabold text-[18px] lg:text-[48px]"
        :class="variant === 'light' ? 'text-black' : 'text-white'"
      >
        <i18n-t keypath="b2b.feedback.title.main">
          <template #highlightedText>
            <span class="text-[#FFC107]">
              {{ t('b2b.feedback.title.highlightedText') }}
            </span>
          </template>
        </i18n-t>
      </h2>
    </div>
    <Card>
      <div
        class="flex flex-col pt-[24px] pb-[52px] px-[17px] lg:px-[48px] overflow-hidden"
        :class="variant === 'light' ? 'bg-[#FFC107] rounded-[9.5px] lg:rounded-[20px]' : 'bg-transparent'"
      >
        <div class="flex flex-col gap-y-[40px] lg:flex-row lg:gap-y-0">
          <div class="lg:w-[50%]">
            <p class="font-notino font-bold text-[18px] lg:text-[24px] mb-[40px] text-[#535353]">
              {{ t('b2b.feedback.subtitle') }}
            </p>
            <div class="flex flex-col gap-y-[25px] mb-[40px]">
              <TextInput
                :variant="variant"
                :label="t('b2b.feedback.form.companyName.label')"
                v-model="formData.company"
                :errors="validationErrors.company"
              />
              <TextInput
                :variant="variant"
                :label="t('b2b.feedback.form.employeeCount.label')"
                v-model="formData.countOfStaff"
                :errors="validationErrors.countOfStaff"
              />
              <MultiSelect
                :variant="variant"
                :label="t('b2b.feedback.form.workFormat.label')"
                v-model="formData.format"
                :options="formatOptions"
                :errors="validationErrors.format"
              />
              <TextInput
                :variant="variant"
                :label="t('b2b.feedback.form.username.label')"
                v-model="formData.name"
                :errors="validationErrors.name"
              />
              <PhoneInput
                ref="phoneInputElement"
                :variant="variant"
                :label="t('b2b.feedback.form.phone.label')"
                v-model="phoneNumber"
                :errors="validationErrors.phone"
              />
              <TextInput
                :variant="variant"
                :label="t('b2b.feedback.form.email.label')"
                v-model="formData.email"
                :errors="validationErrors.email"
              />
            </div>
            <Btn large :variant="variant" @click="submit">{{ t('b2b.feedback.button') }}</Btn>
          </div>
          <div class="lg:w-[50%] relative mx-auto">
           <div class="lg:absolute lg:bottom-[-50px] lg:right-[-50px] ">
            <Bee class="h-[262px] w-[275px] md:h-[579px] md:w-[554px]"/>
           </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '~/components/ui/Card.vue';
import TextInput from '~/components/ui/TextInput.vue';
import Btn from '~/components/ui/Btn.vue';
import Bee from '~/components/icons/Bee.vue';
import MultiSelect from "~/components/ui/MultiSelect.vue";
import PhoneInput from "~/components/ui/PhoneInput.vue";

type TVariant = 'dark' | 'light';

interface Props {
  variant?: TVariant
}

withDefaults(defineProps<Props>(), {
  variant: 'dark'
})

const { gtag } = useGtag()
const {t} = useI18n();
const {isLoading, formData, validationErrors, sendForm} = useB2BNewLeadForm();
const phoneNumber = ref();
const phoneInputElement = ref();

const formatOptions = ['coaching', 'consultations', 'support', 'webinars', 'wellbeing']
  .map(val => {
    return {
      label: t(`b2b.feedback.form.options.${val}`),
      value: t(`b2b.feedback.form.options.${val}`)
    }
  });

const submit = async () => {
  try {
    formData.value.phone = phoneInputElement.value.getFullNumber();
    formData.value.country = phoneInputElement.value.getCountryCode();
    await sendForm();
    gtag('event', 'Lead', {});
    phoneNumber.value = null;
  } catch (e) {
    console.error(e);
  }
}
</script>

